enum RoutingPath {
  Dashboard = '/',
  Reward = '/reward',
  Coupon = '/coupon',
  Game = '/game',
}
export default RoutingPath;
